export class TableWidget {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<WidgetTableColumn>",
            "format": ""
        },
        {
            "name": "rows",
            "baseName": "rows",
            "type": "Array<WidgetTableRow>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableWidget.attributeTypeMap;
    }
    constructor() {
    }
}
